import React, { useContext, useEffect, useState, useRef } from "react";
import Footer11 from "../shared/Footer11";
import Navbar11 from "../shared/Navbar11";
import Sidebar11 from "../shared/Sidebar11";
import { useNavigate } from "react-router-dom";
import { ContextBoard } from "../../context/ContextBoard";
import config from "../../config";
import Select from "react-select";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { setSessionData, getSessionData } from "../../cache";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

function DataNotFound11() {
  const { setClass11Castecode, setClass11Divyangcode } =
    useContext(ContextBoard);
  const Navigate = useNavigate();

  const [errors, setErrors] = useState({});
  const [isAgreed, setIsAgreed] = useState(false);
  const [loading, setLoading] = useState(true);
  const [blockList, setBlockList] = useState([]);
  const [casteList, setCasteList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [divyangList, setDivyangList] = useState([]);
  const [mediumList, setMediumList] = useState([]);
  const [religionList, setReligionList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [academicSessionList, setAcademicSessionList] = useState([]);
  const [coresubject, setCoresubject] = useState([]);
  const [matribhasa, setMatribhasa] = useState([]);
  const [compulsory, setCompulsory] = useState([]);
  const [compulsoryfilter, setCompulsoryfilter] = useState([]);
  const [artsSubjects, setArtsSubjects] = useState([]);
  const [optionalsubj, setOptionalsubj] = useState([]);
  const [optionalfiltersubj, setOptionalfiltersubj] = useState([]);
  const [additionalsubj, setAdditionalsubj] = useState([]);
  const [additionalfiltersubj, setAdditionalfiltersubj] = useState([]);
  const [electivefiltersubj, setElectivefiltersubj] = useState([]);
  const [compulsoryonename, setCompulsoryonename] = useState("");
  const [compulsorytwoname, setCompulsorytwoname] = useState("");
  const [isPreviewed, setIsPreviewed] = useState(false);

  const [showSubmit, setShowSubmit] = useState(false);

  const [EndDate, setEndDate] = useState("");
  const date = new Date();
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const currentDate = `${day}-${month}-${year}`;
  const parseDate = (str) => {
    const [dd, mm, yyyy] = str.split("-");
    return new Date(`${yyyy}-${mm}-${dd}`);
  };
  const session1Ref = useRef(null);
  const session2Ref = useRef(null);

  const [formData, setFormData] = useState({
    candidate_name: "",
    gender: "",
    date_of_birth: "",
    fathers_name: "",
    mothers_name: "",
    religion: "",
    nationality: "Indian",
    aadhaar_no: "",
    divyang_val: "",
    caste_val: "",
    area: "",
    state_val: "",
    district_val: "",
    block_val: "",
    address_val: "",
    pin_no: "",
    contact_no: "",
    email_id: "",
    category_choice: "",
    // academiC_SESSION: "",
    academiC_SESSION1: "",
    academiC_SESSION2: "",
    board_name: "JAC",
    apaar_id: "",
    stream: "",
    coresubject: "",
    matribhasa: "",
    compulsory_one: "",
    compulsory_two: "",
    additionalsubject: "",
    registration_no: "",
  });

  const [selectedArtsSubjects, setSelectedArtsSubjects] = useState({
    arts_optional_one: "",
    arts_optional_two: "",
    arts_optional_three: "",
  });

  const [optional1, setOptional1] = useState("");
  const [optional2, setOptional2] = useState("");
  const [artselective, setArtselective] = useState("");

  const [selectedSubjectNames, setSelectedSubjectNames] = useState({
    coresubject: "",
    matribhasa: "",
    // compulsory_one: "",
    // compulsory_two: "",
    additionalsubject: "",
    arts_optional_one: "",
    arts_optional_two: "",
    arts_optional_three: "",
    optional1: "",
    optional2: "",
    artselective: "",
  });

  useEffect(() => {
    // ✅ Hindi restrictions
    if (
      formData.coresubject === "HNA" &&
      (formData.additionalsubject === "HIN" || artselective === "HIN")
    ) {
      setFormData((prev) => ({
        ...prev,
        additionalsubject: "",
      }));
      if (artselective === "HIN") {
        setArtselective("");
        setSelectedSubjectNames((prev) => ({ ...prev, artselective: "" }));
      }
    }
    // ✅ English restrictions
    if (
      formData.coresubject === "ENA" &&
      (formData.additionalsubject === "ENG" ||
        formData.additionalsubject === "FEN" ||
        artselective === "ENG" ||
        artselective === "FEN")
    ) {
      setFormData((prev) => ({
        ...prev,
        additionalsubject: "",
      }));
      if (artselective === "ENG" || artselective === "FEN") {
        setArtselective("");
        setSelectedSubjectNames((prev) => ({ ...prev, artselective: "" }));
      }
    }

    // ✅ Science stream restrictions
    if (formData.stream === "SCIENCE") {
      if (
        (optional1 === "MAT" || optional2 === "MAT") &&
        formData.additionalsubject === "STA"
      ) {
        setFormData((prev) => ({
          ...prev,
          additionalsubject: "",
        }));
      }
      if (
        (optional1 === "STA" || optional2 === "STA") &&
        formData.additionalsubject === "MAT"
      ) {
        setFormData((prev) => ({
          ...prev,
          additionalsubject: "",
        }));
      }
    }

    // ✅ Commerce stream restrictions
    if (formData.stream === "COMMERCE") {
      if (
        (optional1 === "MAT" || optional2 === "MAT") &&
        formData.additionalsubject === "CAE"
      ) {
        setFormData((prev) => ({
          ...prev,
          additionalsubject: "",
        }));
      }
      if (
        (optional1 === "CAE" || optional2 === "CAE") &&
        formData.additionalsubject === "MAT"
      ) {
        setFormData((prev) => ({
          ...prev,
          additionalsubject: "",
        }));
      }
    }

    // ✅ Arts stream restrictions
    if (formData.stream === "ARTS") {
      const { arts_optional_one, arts_optional_two, arts_optional_three } =
        selectedArtsSubjects;

      // If MAT selected anywhere, clear additionalsubject if it's MAT/STA
      if (
        arts_optional_one === "MAT" ||
        arts_optional_two === "MAT" ||
        arts_optional_three === "MAT"
      ) {
        if (
          formData.additionalsubject === "MAT" ||
          formData.additionalsubject === "STA"
        ) {
          setFormData((prev) => ({
            ...prev,
            additionalsubject: "",
          }));
        }
      }

      // If STA selected anywhere, clear additionalsubject if it's MAT/STA
      if (
        arts_optional_one === "STA" ||
        arts_optional_two === "STA" ||
        arts_optional_three === "STA"
      ) {
        if (
          formData.additionalsubject === "STA" ||
          formData.additionalsubject === "MAT"
        ) {
          setFormData((prev) => ({
            ...prev,
            additionalsubject: "",
          }));
        }
      }
    }
  }, [
    formData.coresubject,
    formData.stream,
    formData.additionalsubject,
    optional1,
    optional2,
    selectedArtsSubjects,
  ]);

  useEffect(() => {
    if (formData.stream === "ARTS") {
      const { arts_optional_one, arts_optional_two, arts_optional_three } =
        selectedArtsSubjects;

      // If MAT is selected anywhere → reset STA from additional subject
      if (
        (arts_optional_one === "MAT" ||
          arts_optional_two === "MAT" ||
          arts_optional_three === "MAT") &&
        formData.additionalsubject === "STA"
      ) {
        setFormData((prev) => ({ ...prev, additionalsubject: "" }));
        return;
      }

      // If STA is selected anywhere → reset MAT from additional subject
      if (
        (arts_optional_one === "STA" ||
          arts_optional_two === "STA" ||
          arts_optional_three === "STA") &&
        formData.additionalsubject === "MAT"
      ) {
        setFormData((prev) => ({ ...prev, additionalsubject: "" }));
        return;
      }
    }
  }, [
    formData.stream,
    formData.additionalsubject,
    selectedArtsSubjects.arts_optional_one,
    selectedArtsSubjects.arts_optional_two,
    selectedArtsSubjects.arts_optional_three,
  ]);

  useEffect(() => {
    // 🔹 Science stream MAT–STA restrictions
    if (formData.stream === "SCIENCE") {
      // If MAT chosen in optional1/optional2 → additional subject cannot be STA
      if (
        (optional1 === "MAT" || optional2 === "MAT") &&
        formData.additionalsubject === "STA"
      ) {
        setFormData((prev) => ({ ...prev, additionalsubject: "" }));
        return;
      }

      // If STA chosen in optional1/optional2 → additional subject cannot be MAT
      if (
        (optional1 === "STA" || optional2 === "STA") &&
        formData.additionalsubject === "MAT"
      ) {
        setFormData((prev) => ({ ...prev, additionalsubject: "" }));
        return;
      }
    }

    // 🔹 Commerce stream MAT–CAE restrictions
    if (formData.stream === "COMMERCE") {
      // If MAT chosen in optional1/optional2 → additional subject cannot be CAE
      if (
        (optional1 === "MAT" || optional2 === "MAT") &&
        formData.additionalsubject === "CAE"
      ) {
        setFormData((prev) => ({ ...prev, additionalsubject: "" }));
        return;
      }

      // If CAE chosen in optional1/optional2 → additional subject cannot be MAT
      if (
        (optional1 === "CAE" || optional2 === "CAE") &&
        formData.additionalsubject === "MAT"
      ) {
        setFormData((prev) => ({ ...prev, additionalsubject: "" }));
        return;
      }
    }
  }, [formData.stream, formData.additionalsubject, optional1, optional2]);

  useEffect(() => {
    setLoading(false);
    // ✅ Read encrypted data from sessionStorage
    const blockList = getSessionData("blockList") || [];
    const casteList = getSessionData("casteList") || [];
    const districtList = getSessionData("districtList") || [];
    const divyangList = getSessionData("divyangList") || [];
    const mediumList = getSessionData("mediumList") || [];
    const religionList = getSessionData("religionList") || [];
    const stateList = getSessionData("stateList") || [];
    const coreSubjects = getSessionData("coreSubjects") || [];
    const matri_BhasaSubjects = getSessionData("matri_BhasaSubjects") || [];
    const compulsory_Paper_2Subjects =
      getSessionData("compulsory_Paper_2Subjects") || [];
    const additional_Subjects = getSessionData("additional_Subjects") || [];
    const elective_Subjects = getSessionData("electivesubj") || [];
    const optional_Paper_1_2Subjects =
      getSessionData("optional_Paper_1_2Subjects") || [];
    const cL11EndDate = getSessionData("cL11EndDate") || {};
    const academicSessionList = getSessionData("noDataFoundSessionList") || {};

    // ✅ Now set states
    setEndDate(cL11EndDate?.cL_11_REGISTRATION_END_DATE || "");
    setBlockList(Array.isArray(blockList) ? blockList : []);
    setCasteList(Array.isArray(casteList) ? casteList : []);
    setDistrictList(Array.isArray(districtList) ? districtList : []);
    setDivyangList(Array.isArray(divyangList) ? divyangList : []);
    setMediumList(Array.isArray(mediumList) ? mediumList : []);
    setReligionList(Array.isArray(religionList) ? religionList : []);
    setStateList(Array.isArray(stateList) ? stateList : []);
    setAcademicSessionList(
      Array.isArray(academicSessionList) ? academicSessionList : []
    );
    setCoresubject(Array.isArray(coreSubjects) ? coreSubjects : []);
    setMatribhasa(
      Array.isArray(matri_BhasaSubjects) ? matri_BhasaSubjects : []
    );
    setCompulsory(
      Array.isArray(compulsory_Paper_2Subjects)
        ? compulsory_Paper_2Subjects
        : []
    );
    setAdditionalsubj(
      Array.isArray(additional_Subjects) ? additional_Subjects : []
    );
    setOptionalsubj(
      Array.isArray(optional_Paper_1_2Subjects)
        ? optional_Paper_1_2Subjects
        : []
    );
    setElectivefiltersubj(
      Array.isArray(elective_Subjects) ? elective_Subjects : []
    );

    setLoading(false);
  }, []);
  const handleChange = (e) => {
    const { name, value = "" } = e.target;

    let formattedValue = value;

    // Formatting logic
    if (
      name === "candidate_name" ||
      name === "fathers_name" ||
      name === "mothers_name"
    ) {
      formattedValue = value
        .toUpperCase()
        .replace(/[^A-Z\s]/g, "")
        .slice(0, 35);
    }

    if (name === "aadhaar_no") {
      const digitsOnly = value.replace(/\D/g, "").slice(0, 12);
      formattedValue = digitsOnly.replace(
        /(\d{4})(\d{4})(\d{1,4})?/,
        (_, p1, p2, p3 = "") => [p1, p2, p3].filter(Boolean).join(" ")
      );
    }
    if (name === "registraton_no") {
      const digitsOnly = value.replace(/\D/g, ""); // remove all non-digits
      const limitedDigits = digitsOnly.slice(0, 14); // cap at 14 digits

      formattedValue = limitedDigits; // no formatting applied
    }

    if (name === "category_choice") {
      setFormData((prev) => ({
        ...prev,
        category_choice: formattedValue,
        stream: "",
        roll_no: "",
      }));
    }
    /* if (name === "apaar_id") {
      formattedValue = value
        .replace(/\D/g, "")
        .slice(0, 12)
        .replace(/(\d{4})(?=\d)/g, "$1  ")
        .trim();
    } */

    if (name === "academiC_SESSION1" && formattedValue.length === 2) {
      session2Ref.current.focus();
    }

    if (name === "academiC_SESSION1" || name === "academiC_SESSION2") {
      formattedValue = value.replace(/[^0-9/-]/g, "");
    }

    if (name === "contact_no") {
      formattedValue = value.replace(/\D/g, "").slice(0, 10);
    }

    if (name === "pin_no") {
      formattedValue = value.replace(/\D/g, "").slice(0, 6);
    }

    if (name === "address_val") {
      formattedValue = value.replace(/[^a-zA-Z0-9 ,]/g, "");
    }

    if (name === "email_id") {
      formattedValue = value.toLowerCase().replace(/[^a-z0-9@._]/g, "");
    }
    if (name === "apaar_id") {
      formattedValue = value.replace(/\D/g, "");
    }
    // Dependent dropdown handling
    if (name === "state_val") {
      setFormData((prev) => ({
        ...prev,
        state_val: formattedValue,
        district_val: "", // reset district
        block_val: "", // reset block
      }));
    } else if (name === "district_val") {
      setFormData((prev) => ({
        ...prev,
        district_val: formattedValue,
        block_val: "", // reset block
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: formattedValue,
      }));
    }

    // Clear validation errors on input change
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleArtsSubjects = () => {
    setSelectedSubjectNames((prevData) => ({
      ...prevData,
      coresubject: "",
      matribhasa: "",
      additionalsubject: "",
      arts_optional_one: "",
      arts_optional_two: "",
      arts_optional_three: "",
      optional1: "",
      optional2: "",
      artselective: "",
    }));
    setFormData((prevData) => ({
      ...prevData,
      coresubject: "",
      matribhasa: "",
      compulsory_one: "",
      compulsory_two: "",
      additionalsubject: "",
    }));
    setSelectedArtsSubjects({
      arts_optional_one: "",
      arts_optional_two: "",
      arts_optional_three: "",
    });
    setOptional1("");
    setOptional2("");
    setArtselective("");

    // Include ARTS + ALL
    const filtered = compulsory.filter(
      (subject) => subject.streams === "ARTS" || subject.streams === "ALL"
    );
    setArtsSubjects(filtered);

    const filteredOptional = optionalsubj.filter(
      (subject) => subject.streams === "ARTS" || subject.streams === "ALL"
    );
    const filteredadditional = additionalsubj.filter(
      (subject) => subject.streams === "ARTS" || subject.streams === "ALL"
    );
    setAdditionalfiltersubj(filteredadditional);
    setOptionalfiltersubj(filteredOptional);
  };

  const handleSetCompulsorySubjects = (selectedStream) => {
    setSelectedSubjectNames((prevData) => ({
      ...prevData,
      coresubject: "",
      matribhasa: "",
      additionalsubject: "",
      arts_optional_one: "",
      arts_optional_two: "",
      arts_optional_three: "",
      optional1: "",
      optional2: "",
      artselective: "",
    }));
    setFormData((prevData) => ({
      ...prevData,
      coresubject: "",
      matribhasa: "",
      compulsory_one: "",
      compulsory_two: "",
      additionalsubject: "",
    }));
    setSelectedArtsSubjects({
      arts_optional_one: "",
      arts_optional_two: "",
      arts_optional_three: "",
    });
    setOptional1("");
    setOptional2("");
    setArtselective("");

    if (!Array.isArray(compulsory)) return;
    if (!Array.isArray(optionalsubj)) return;
    if (!Array.isArray(additionalsubj)) return;

    // Include selected stream + ALL
    const filteredSubjects = compulsory.filter(
      (subject) =>
        subject.streams === selectedStream || subject.streams === "ALL"
    );
    const filteredOptionalSubjects = optionalsubj.filter(
      (subject) =>
        subject.streams === selectedStream || subject.streams === "ALL"
    );
    const filteredadditionalSubjects = additionalsubj.filter(
      (subject) =>
        subject.streams === selectedStream || subject.streams === "ALL"
    );

    setAdditionalfiltersubj(filteredadditionalSubjects);
    setOptionalfiltersubj(filteredOptionalSubjects);

    const [firstSubject, secondSubject] = filteredSubjects;
    setCompulsoryonename(firstSubject?.subjecT_NAME || "");
    setCompulsorytwoname(secondSubject?.subjecT_NAME || "");

    setFormData((prev) => ({
      ...prev,
      compulsory_one: firstSubject?.subjecT_ID || "",
      compulsory_two: secondSubject?.subjecT_ID || "",
    }));
  };

  const handleArtsOptionalChange = (e) => {
    const { name, value } = e.target;

    setSelectedArtsSubjects((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleButtonClick = async () => {
    if (!isAgreed) {
      await Swal.fire({
        icon: "warning",
        title: "Please Agree",
        text: "You must agree before submitting the form.",
      });
      return;
    }
    const token = sessionStorage.getItem("tokenclassxi");
    const cleanAadhaar = (formData.aadhaar_no || "").replace(/\D/g, "");

    const commonPayload = {
      studenT_EXAM_CATEGORY_DESCRIPTION: formData.category_choice || "",
      // academiC_SESSION: formData.academiC_SESSION || "",
      academiC_SESSION: `20${formData.academiC_SESSION1}-20${formData.academiC_SESSION2}`,
      candidate_name: formData.candidate_name || "",
      // studenT_EXAM_CATEGORY: formData.category_choice === "REGULAR" ? "R" : "P",
      gender: formData.gender || "",
      dob: formData.date_of_birth || "",
      fatheR_NAME: formData.fathers_name || "",
      REGISTRATION_NO: formData.registration_no || "",
      motheR_NAME: formData.mothers_name || "",
      religion: formData.religion || "",
      aadhaR_CARD: cleanAadhaar,
      divyang: formData.divyang_val || "",
      cast: formData.caste_val || "",
      contacT_NO: formData.contact_no || "",
      emaiL_ID: formData.email_id || "",
      area: formData.area || "",
      state: formData.state_val || "",
      districT_ID: formData.district_val || "",
      block: formData.block_val || "",
      address: formData.address_val.toUpperCase() || "",
      pincode: formData.pin_no || "",
      stream: formData.stream || "",
      apaaR_ID: formData.apaar_id || "",
      // nationality: "INDIAN",
      boarD_NAME: formData.board_name || "",
      schooL_DIST_CODE: sessionStorage.getItem("district") || "",
    };

    // 🔵 Stream-wise Subjects
    let finalPayload = {};

    if (formData.stream === "SCIENCE" || formData.stream === "COMMERCE") {
      finalPayload = {
        ...commonPayload,
        subjecT_1_A_TYPE: "CL",
        subjecT_1_A_CODE: formData.coresubject || "",
        subjecT_1_B_TYPE: "MB",
        subjecT_1_B_CODE: formData.matribhasa || "",
        subjecT_2_TYPE: "C1",
        subjecT_2_CODE: formData.compulsory_one || "",
        subjecT_3_TYPE: "C2",
        subjecT_3_CODE: formData.compulsory_two || "",
        subjecT_4_TYPE: "O1",
        subjecT_4_CODE: optional1 || "",
        subjecT_5_TYPE: "O2",
        subjecT_5_CODE: optional2 || "",
        subjecT_6_TYPE: "AL",
        subjecT_6_CODE: formData.additionalsubject || "",
      };
    } else if (formData.stream === "ARTS") {
      finalPayload = {
        ...commonPayload,
        subjecT_1_A_TYPE: "CL",
        subjecT_1_A_CODE: formData.coresubject || "",
        subjecT_1_B_TYPE: "MB",
        subjecT_1_B_CODE: formData.matribhasa || "",
        subjecT_2_TYPE: "O1",
        subjecT_2_CODE: selectedArtsSubjects.arts_optional_one || "",
        subjecT_3_TYPE: "O2",
        subjecT_3_CODE: selectedArtsSubjects.arts_optional_two || "",
        subjecT_4_TYPE: "O3",
        subjecT_4_CODE: selectedArtsSubjects.arts_optional_three || "",
        subjecT_5_TYPE: "EL",
        subjecT_5_CODE: artselective || "",
        subjecT_6_TYPE: "AL",
        subjecT_6_CODE: formData.additionalsubject || "",
      };
    }

    try {
      setLoading(true);
      const apiEndpoint = `${config.API_BASE_URL}/InsertDataNotFound_CL11`;

      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(finalPayload),
      });

      const result = await response.json();

      if (response.ok) {
        setLoading(false);
        Swal.fire("Success", "Your data added successfully!", "success").then(
          () => {
            Navigate("/class-xi-data-not-found-list");
          }
        );
      } else {
        setLoading(false);
        Swal.fire(
          "Error",
          result.message || "Failed to submit student details.",
          "error"
        );
        console.error("API Error:", result);
      }
    } catch (error) {
      setLoading(false);
      Swal.fire("Error", "Network error. Please try again.", "error");
      console.error("Network Error:", error);
    }
  };

  const handlePreview = async (e) => {
    e.preventDefault();
    setLoading(true);
    const trimmed = (val) => (val || "").trim();

    const newErrors = {};

    setTimeout(() => {
      if (!formData.board_name)
        newErrors.board_name = "Board Name is required.";
      if (!formData.category_choice)
        newErrors.category_choice = "Category is required.";
      /* if (!formData.academiC_SESSION)
        newErrors.academiC_SESSION = "Academic session is required."; */

      if (!trimmed(formData.academiC_SESSION1)) {
        newErrors.academiC_SESSION1 = "Academic Session is required.";
      } else if (!/^\d{2}$/.test(formData.academiC_SESSION1)) {
        newErrors.academiC_SESSION1 = "Academic Session must be 2 digits.";
      }
      if (!trimmed(formData.academiC_SESSION2)) {
        newErrors.academiC_SESSION2 = "Academic Session is required.";
      } else if (!/^\d{2}$/.test(formData.academiC_SESSION2)) {
        newErrors.academiC_SESSION2 = "Academic Session must be 2 digits.";
      }
      const candidateName = trimmed(formData.candidate_name);
      const fathersName = trimmed(formData.fathers_name);
      const mothersName = trimmed(formData.mothers_name);

      if (candidateName) {
        if (
          fathersName &&
          mothersName &&
          candidateName.toLowerCase() === fathersName.toLowerCase() &&
          candidateName.toLowerCase() === mothersName.toLowerCase()
        ) {
          newErrors.candidate_name =
            "Candidate name cannot be the same as Father's and Mother's name.";
          newErrors.fathers_name =
            "Father's name cannot be the same as Candidate and Mother's name.";
          newErrors.mothers_name =
            "Mother's name cannot be the same as Candidate and Father's name.";
          toast.error(
            "All names are the same! Candidate, Father's name, and Mother's name cannot be the same."
          );
        } else {
          if (
            fathersName &&
            candidateName.toLowerCase() === fathersName.toLowerCase()
          ) {
            newErrors.candidate_name =
              "Candidate name cannot be the same as Father's name.";
            newErrors.fathers_name =
              "Father's name cannot be the same as Candidate name.";
            toast.error(
              "Duplicate names! Candidate name cannot be the same as Father's name."
            );
          }
          if (
            mothersName &&
            candidateName.toLowerCase() === mothersName.toLowerCase()
          ) {
            newErrors.candidate_name =
              "Candidate name cannot be the same as Mother's name.";
            newErrors.mothers_name =
              "Mother's name cannot be the same as Candidate name.";
            toast.error(
              "Duplicate names! Candidate name cannot be the same as Mother's name."
            );
          }
          if (
            fathersName &&
            mothersName &&
            fathersName.toLowerCase() === mothersName.toLowerCase()
          ) {
            newErrors.fathers_name =
              "Father's name cannot be the same as Mother's name.";
            newErrors.mothers_name =
              "Mother's name cannot be the same as Father's name.";
            toast.error(
              "Duplicate names! Father's name cannot be the same as Mother's name."
            );
          }
        }
      }

      if (!formData.candidate_name)
        newErrors.candidate_name = "Candidate Name is required.";
      if (!formData.gender) newErrors.gender = "Gender is required.";
      if (!formData.date_of_birth)
        newErrors.date_of_birth = "Date of Birth is required.";
      if (!formData.divyang_val)
        newErrors.divyang_val = "Divyang selection is required.";
      if (!formData.caste_val) newErrors.caste_val = "Caste is required.";
      if (!/^\d{12}$/.test(formData.apaar_id) && formData.apaar_id) {
        newErrors.apaar_id = "Apaar ID must be exactly 12 digits.";
      }
      // Validation logic here (abbreviated for brevity)
      if (!formData.religion) newErrors.religion = "Religion is required.";
      if (!formData.mothers_name)
        newErrors.mothers_name = "Mother Name is required.";
      if (!formData.fathers_name)
        newErrors.fathers_name = "Father Name is required.";

      const aadhaar = (formData.aadhaar_no || "").replace(/\D/g, "");
      if (!aadhaar) {
        newErrors.aadhaar_no = "Aadhaar number is required.";
      } else if (!/^\d{12}$/.test(aadhaar)) {
        newErrors.aadhaar_no = "Aadhaar number must be 12 digits.";
      }
      if (!formData.registration_no) {
        newErrors.registration_no = "Registration number is required.";
      } else if (!/^[A-Za-z0-9]{12,14}$/.test(formData.registration_no)) {
        newErrors.registration_no =
          "Registration number must be 12–14 characters (letters or digits only).";
      }
      if (!formData.area) newErrors.area = "Area is required.";
      if (!formData.stream) newErrors.stream = "Stream is required.";

      // More validations for streams and subjects, as in your code...
      if (formData.stream === "SCIENCE" || formData.stream === "COMMERCE") {
        if (!formData.coresubject) {
          newErrors.coresubject = "Core Language is Required.";
        }
        if (formData.coresubject === "HNB") {
          if (!formData.matribhasa) {
            newErrors.matribhasa = "Matri Bhasa is Required.";
          }
        }
        if (!optional1) {
          newErrors.sc_optional_one = "Optional 1 is Required.";
        }
        if (!optional2) {
          newErrors.sc_optional_two = "Optional 2 is Required.";
        }
      }
      if (formData.stream === "ARTS") {
        if (!formData.coresubject) {
          newErrors.coresubject = "Core Language is Required.";
        }
        if (formData.coresubject === "HNB") {
          if (!formData.matribhasa) {
            newErrors.matribhasa = "Matri Bhasa is Required.";
          }
        }
        if (!selectedArtsSubjects.arts_optional_one) {
          newErrors.arts_optional_one = "Optional 1 is Required.";
        }
        if (!selectedArtsSubjects.arts_optional_two) {
          newErrors.arts_optional_two = "Optional 2 is Required.";
        }
        if (!selectedArtsSubjects.arts_optional_three) {
          newErrors.arts_optional_three = "Optional 3 is Required.";
        }
        if (!artselective) {
          newErrors.arts_elective_one = "Elective Language is Required.";
        }
      }
      if (!trimmed(formData.state_val))
        newErrors.state_val = "State is required.";
      if (!trimmed(formData.district_val))
        newErrors.district_val = "District is required.";
      if (!trimmed(formData.block_val))
        newErrors.block_val = "Block is required.";
      if (!trimmed(formData.address_val))
        newErrors.address_val = "Address is required.";

      if (!trimmed(formData.pin_no)) {
        newErrors.pin_no = "Pin code is required.";
      } else if (!/^\d{6}$/.test(formData.pin_no)) {
        newErrors.pin_no = "Pin code must be 6 digits.";
      }

      if (!trimmed(formData.contact_no)) {
        newErrors.contact_no = "Contact number is required.";
      } else if (!/^\d{10}$/.test(formData.contact_no)) {
        newErrors.contact_no = "Contact number must be 10 digits.";
      }

      if (
        formData.email_id &&
        !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.email_id)
      ) {
        newErrors.email_id = "Invalid email format.";
      }

      // Other validations...

      setErrors(newErrors);
      const noErrors = Object.keys(newErrors).length === 0;
      setShowSubmit(noErrors);
      if (!noErrors) {
        const firstErrorKey = Object.keys(newErrors)[0];
        const firstErrorElement = document.querySelector(
          `[name="${firstErrorKey}"]`
        );
        if (firstErrorElement) {
          firstErrorElement.focus();
        }
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
        setIsPreviewed(true);
      }
      setLoading(false);
    }, 500);
  };
  const handleChangeDate = (date) => {
    if (date) {
      const dd = String(date.getDate()).padStart(2, "0");
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const yyyy = date.getFullYear();

      setFormData((prev) => ({
        ...prev,
        date_of_birth: `${dd}-${mm}-${yyyy}`,
      }));
    } else {
      setFormData((prev) => ({ ...prev, date_of_birth: "" }));
    }
  };

  const handleKeyDown = (e) => {
    if (
      e.key === "Backspace" &&
      e.target.name === "academiC_SESSION2" &&
      e.target.value.length === 0
    ) {
      session1Ref.current.focus();
    }
  };
  useEffect(() => {
    setSelectedSubjectNames((prev) => ({
      ...prev,
      additionalsubject: "",
    }));
  }, [formData.coresubject]);
  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <div class="container-scroller">
        <Navbar11 />
        <div class="container-fluid page-body-wrapper">
          <Sidebar11 />
          {loading && (
            <div className="custom-loader-container">
              <div className="custom-loader"></div>
            </div>
          )}
          <div class="main-panel">
            {/* {parseDate(currentDate) >= parseDate(EndDate) ? (
              <div
                class="content-wrapper"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <h1 className="text-danger">
                  <strong>Registration is closed.</strong>
                </h1>
              </div>
            ) : ("")} */}
            <div class="content-wrapper">
              <div class="row">
                <div class="col-md-12 mb-1">
                  <section class="content-header ">
                    <h1 className="text-danger">
                      <i class="fa fa-user-plus"></i>&nbsp; Add Data Not Found
                      Student
                    </h1>
                    <ol class="breadcrumb">
                      <li>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            Navigate("/class-xi-dashboard");
                          }}
                        >
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            stroke-width="0"
                            viewBox="0 0 512 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginTop: "-4px" }}
                          >
                            <path d="M256 64C132.3 64 32 164.2 32 287.9c0 57 21.3 109 56.3 148.5 1.1 1.2 2.1 2.4 3.2 3.5C96.3 445 103 448 110 448c7.1 0 13.8-3 18.6-8.2 31.6-34.4 77-55.9 127.4-55.9s95.8 21.6 127.4 55.9c4.8 5.2 11.5 8.2 18.6 8.2 7 0 13.7-2.9 18.5-8.1 1.1-1.2 2.1-2.3 3.2-3.5 35-39.5 56.3-91.5 56.3-148.5C480 164.2 379.7 64 256 64zm-14 45.9c0-7.7 6.3-14 14-14s14 6.3 14 14v36c0 7.7-6.3 14-14 14s-14-6.3-14-14v-36zm-128 192H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm51.5-104.5c-5.4 5.4-14.4 5.4-19.8 0L120.2 172c-5.4-5.4-5.4-14.4 0-19.8s14.4-5.4 19.8 0l25.5 25.5c5.4 5.4 5.4 14.3 0 19.7zm160.6 34.5l-47.5 75.5c-1.9 2.6-4.3 5.1-7 7-13.5 9.7-32.3 6.5-42-7s-6.5-32.3 7-42l75.5-47.5c3.4-2.4 8.1-2.5 11.7 0 4.5 3.2 5.5 9.5 2.3 14zm40.2-34.5c-5.4 5.4-14.4 5.4-19.8 0s-5.4-14.4 0-19.8l25.5-25.5c5.4-5.4 14.4-5.4 19.8 0s5.4 14.4 0 19.8l-25.5 25.5zM434 301.9h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"></path>
                          </svg>{" "}
                          Home&nbsp;
                        </a>
                      </li>
                      <li class="active"> Add Student</li>
                    </ol>
                    <h3></h3>
                  </section>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 mb-4">
                  <div class="card">
                    <div class="card-header card-green">
                      <h4 class="mb-0 p-2">Student Details</h4>
                    </div>
                    <div class="card-body">
                      <div class="card-body">
                        <div class="row">
                          <div
                            class="col-lg-9"
                            style={{ borderRight: "1px solid #CED4DA" }}
                          >
                            <div class="row">
                              <div class="col-lg-4 col-m-4">
                                <div class="form-group mb-3">
                                  <label>Board Name</label>
                                  <select
                                    className={`form-select form-control-sm disable ${
                                      errors.board_name ? "is-invalid" : ""
                                    }`}
                                    name="board_name"
                                    id="board_name"
                                    disabled
                                    onChange={handleChange}
                                    value={formData.board_name || ""}
                                  >
                                    <option value="">Choose Board</option>
                                    <option value="JAC" selected>
                                      JAC
                                    </option>
                                    <option value="CBSE">CBSE</option>
                                    <option value="ICSE">ICSE</option>
                                    <option value="OTHER">OTHERS</option>
                                  </select>
                                  {errors.board_name && (
                                    <div className="text-danger mt-1 small">
                                      {errors.board_name}
                                    </div>
                                  )}
                                </div>
                              </div>

                              <div class="col-lg-4 col-m-4">
                                <div class="form-group mb-3">
                                  <label>
                                    Category Choice{" "}
                                    <span class="text-danger">*</span>
                                  </label>
                                  <select
                                    disabled={isPreviewed}
                                    className={`form-select form-control-sm disable ${
                                      errors.category_choice ? "is-invalid" : ""
                                    }`}
                                    id="category_choice"
                                    name="category_choice"
                                    value={formData.category_choice}
                                    onChange={handleChange}
                                  >
                                    <option value="">Choose Category</option>
                                    <option value="REGULAR">REGULAR </option>
                                    <option value="EX-REGULAR">
                                      EX-REGULAR
                                    </option>
                                    <option value="PRIVATE">PRIVATE </option>
                                  </select>
                                  {errors.category_choice && (
                                    <div className="text-danger mt-1 small">
                                      {errors.category_choice}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group mb-3">
                                  <label>
                                    Stream <span class="text-danger">*</span>
                                  </label>
                                  <select
                                    className={`form-select form-control-sm disable ${
                                      errors.stream ? "is-invalid" : ""
                                    }`}
                                    name="stream"
                                    id="stream"
                                    value={formData.stream}
                                    disabled={
                                      !formData.category_choice || isPreviewed
                                    }
                                    onChange={(e) => {
                                      const selectedStream = e.target.value;
                                      setFormData({
                                        ...formData,
                                        stream: selectedStream,
                                      });

                                      if (
                                        selectedStream === "SCIENCE" ||
                                        selectedStream === "COMMERCE"
                                      ) {
                                        handleSetCompulsorySubjects(
                                          selectedStream
                                        );
                                      } else {
                                        handleArtsSubjects();
                                      }
                                    }}
                                  >
                                    <option value="">Choose Stream</option>

                                    {getSessionData("approveD_SCI") === "YES" &&
                                      formData.category_choice !==
                                        "PRIVATE" && (
                                        <option value="SCIENCE">SCIENCE</option>
                                      )}
                                    {getSessionData("approveD_COMM") ===
                                      "YES" && (
                                      <option value="COMMERCE">COMMERCE</option>
                                    )}
                                    {getSessionData("approveD_ARTS") ===
                                      "YES" && (
                                      <option value="ARTS">ARTS</option>
                                    )}
                                  </select>
                                  {errors.stream && (
                                    <div className="text-danger mt-1 small">
                                      {errors.stream}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div class="col-lg-12">
                                <hr style={{ margin: "0 0 10px 0" }} />
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-lg-6 col-m-6">
                                <div class="form-group  mb-3">
                                  <label>
                                    Name of Student{" "}
                                    <span class="text-danger">*</span>
                                  </label>
                                  <div class="input-group">
                                    <input
                                      type="text"
                                      className={`form-control form-control-sm disable ${
                                        errors.candidate_name
                                          ? "is-invalid"
                                          : ""
                                      }`}
                                      maxlength="35"
                                      placeholder="Cadidate Name"
                                      onChange={handleChange}
                                      name="candidate_name"
                                      value={formData.candidate_name}
                                      // disabled
                                      disabled={isPreviewed}
                                      onBlur={(e) =>
                                        setFormData((prev) => ({
                                          ...prev,
                                          candidate_name: e.target.value
                                            .trim()
                                            .replace(/\s+/g, " "),
                                        }))
                                      }
                                    />
                                    <span
                                      class="input-group-text padding-13"
                                      id="chars"
                                    >
                                      {35 -
                                        (formData.candidate_name?.length || 0)}
                                    </span>
                                  </div>
                                  {errors.candidate_name && (
                                    <div className="text-danger mt-1 small">
                                      {errors.candidate_name}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div class="col-lg-3 col-m-6">
                                <div class="form-group  mb-3">
                                  <label>
                                    Gender <span class="text-danger">*</span>
                                  </label>
                                  <select
                                    value={formData.gender || ""}
                                    name="gender"
                                    className={`form-select form-control-sm disable ${
                                      errors.gender ? "is-invalid" : ""
                                    }`}
                                    disabled={isPreviewed}
                                    onChange={handleChange}
                                  >
                                    <option value="">Select</option>
                                    <option value="MALE">MALE</option>
                                    <option value="FEMALE">FEMALE</option>
                                    <option value="TRANSGENDER">
                                      TRANSGENDER
                                    </option>
                                  </select>
                                  {errors.gender && (
                                    <div className="text-danger mt-1 small">
                                      {errors.gender}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div class="col-lg-3 col-m-6">
                                <div class="form-group  mb-3">
                                  <label>
                                    Date of Birth{" "}
                                    <span class="text-danger">*</span>
                                  </label>
                                  <DatePicker
                                    minDate={new Date(1975, 0, 1)}
                                    maxDate={new Date()}
                                    selected={
                                      formData.date_of_birth
                                        ? (() => {
                                            const [dd, mm, yyyy] =
                                              formData.date_of_birth.split("-");
                                            return new Date(
                                              Number(yyyy),
                                              Number(mm) - 1,
                                              Number(dd)
                                            );
                                          })()
                                        : null
                                    }
                                    onChange={handleChangeDate}
                                    dateFormat="dd-MM-yyyy"
                                    className={`form-control form-control-sm ${
                                      errors.date_of_birth ? "is-invalid" : ""
                                    }`}
                                    placeholderText="dd-mm-yyyy"
                                    disabled={isPreviewed}
                                    onKeyDown={(e) => e.preventDefault()}
                                    showYearDropdown
                                    scrollableYearDropdown
                                    yearDropdownItemNumber={60}
                                  />

                                  {errors.date_of_birth && (
                                    <div className="text-danger mt-1 small">
                                      {errors.date_of_birth}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div class="col-lg-6 col-md-6">
                                <div class="form-group  mb-3">
                                  <label>
                                    Father’s Name{" "}
                                    <span class="text-danger">*</span>
                                  </label>
                                  <div class="input-group">
                                    <input
                                      type="text"
                                      name="fathers_name"
                                      className={`form-control form-control-sm disable ${
                                        errors.fathers_name ? "is-invalid" : ""
                                      }`}
                                      placeholder="Father’s Name"
                                      onChange={handleChange}
                                      disabled={isPreviewed}
                                      value={formData.fathers_name}
                                      maxLength="35"
                                      onBlur={(e) =>
                                        setFormData((prev) => ({
                                          ...prev,
                                          fathers_name: e.target.value
                                            .trim()
                                            .replace(/\s+/g, " "),
                                        }))
                                      }
                                    />
                                    <span
                                      class="input-group-text padding-13"
                                      id="chars1"
                                    >
                                      {35 -
                                        (formData.fathers_name?.length || 0)}
                                    </span>
                                  </div>
                                  {errors.fathers_name && (
                                    <div className="text-danger mt-1 small">
                                      {errors.fathers_name}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div class="col-lg-6 col-md-6">
                                <div class="form-group  mb-3">
                                  <label>
                                    Mother’s Name{" "}
                                    <span class="text-danger">*</span>
                                  </label>
                                  <div class="input-group">
                                    <input
                                      type="text"
                                      className={`form-control form-control-sm disable ${
                                        errors.mothers_name ? "is-invalid" : ""
                                      }`}
                                      name="mothers_name"
                                      onChange={handleChange}
                                      value={formData.mothers_name}
                                      disabled={isPreviewed}
                                      maxlength="35"
                                      placeholder="Mother’s Name"
                                      onBlur={(e) =>
                                        setFormData((prev) => ({
                                          ...prev,
                                          mothers_name: e.target.value
                                            .trim()
                                            .replace(/\s+/g, " "),
                                        }))
                                      }
                                    />
                                    <span
                                      class="input-group-text padding-13"
                                      id="chars2"
                                    >
                                      {35 -
                                        (formData.mothers_name?.length || 0)}
                                    </span>
                                  </div>
                                  {errors.mothers_name && (
                                    <div className="text-danger mt-1 small">
                                      {errors.mothers_name}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div class="col-lg-3 col-m-6">
                                <div class="form-group  mb-3">
                                  <label>
                                    Religion <span class="text-danger">*</span>
                                  </label>
                                  <select
                                    className={`form-select form-control-sm disable ${
                                      errors.religion ? "is-invalid" : ""
                                    }`}
                                    name="religion"
                                    id="religion"
                                    value={formData.religion || ""}
                                    onChange={handleChange}
                                    disabled={isPreviewed}
                                  >
                                    <option value="">Choose Religion</option>
                                    {religionList.map((religion) => (
                                      <option
                                        key={religion.religioN_ID}
                                        value={religion.religioN_ID}
                                      >
                                        {religion.religioN_NAME}
                                      </option>
                                    ))}
                                  </select>
                                  {errors.religion && (
                                    <div className="text-danger mt-1 small">
                                      {errors.religion}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div class="col-lg-3 col-m-6">
                                <div class="form-group  mb-3">
                                  <label>Nationality</label>
                                  <input
                                    type="text"
                                    value="INDIAN"
                                    disabled
                                    className="form-control form-control-sm"
                                  />
                                </div>
                              </div>
                              <div class="col-lg-6 col-md-6">
                                <div class="form-group  mb-3">
                                  <label>
                                    Student Aadhaar Number{" "}
                                    <span class="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className={`form-control form-control-sm ${
                                      errors.aadhaar_no ? "is-invalid" : ""
                                    }`}
                                    name="aadhaar_no"
                                    maxLength="14" // 12 digits + 2 spaces
                                    placeholder="Enter Aadhaar Number"
                                    value={formData.aadhaar_no}
                                    onChange={handleChange}
                                    disabled={isPreviewed}
                                  />
                                  {errors.aadhaar_no && (
                                    <div className="text-danger mt-1 small">
                                      {errors.aadhaar_no}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div class="col-lg-6 col-md-6">
                                <div class="form-group  mb-3">
                                  <label>
                                    Registration Number
                                    <span class="text-danger">*</span>
                                  </label>
                                  <input
                                    name="registration_no"
                                    type="text"
                                    maxlength="14"
                                    className={`form-control form-control-sm ${
                                      errors.registration_no ? "is-invalid" : ""
                                    }`}
                                    placeholder="Enter Registration Number"
                                    onChange={handleChange}
                                    disabled={isPreviewed}
                                  />
                                  {errors.registration_no && (
                                    <div className="text-danger mt-1 small">
                                      {errors.registration_no}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-3 col-md-12">
                            <div class="form-group mb-4">
                              <label>
                                Divyang <span class="text-danger">*</span>
                              </label>
                              <select
                                className={`form-select form-control-sm ${
                                  errors.divyang_val ? "is-invalid" : ""
                                }`}
                                id="divyang_val"
                                name="divyang_val"
                                value={formData.divyang_val}
                                onChange={handleChange}
                                disabled={isPreviewed}
                              >
                                <option value="">Select</option>
                                {divyangList.map((divyang) => (
                                  <option
                                    key={divyang.divyanG_ID}
                                    value={divyang.divyanG_ID}
                                  >
                                    {divyang.divyanG_NAME}
                                  </option>
                                ))}
                              </select>
                              {errors.divyang_val && (
                                <div className="text-danger mt-1 small">
                                  {errors.divyang_val}
                                </div>
                              )}
                            </div>

                            <div class="form-group mb-3">
                              <label>
                                Caste <span class="text-danger">*</span>
                              </label>
                              <select
                                className={`form-select form-control-sm caste ${
                                  errors.caste_val ? "is-invalid" : ""
                                }`}
                                name="caste_val"
                                id="caste_val"
                                value={formData.caste_val}
                                onChange={handleChange}
                                disabled={isPreviewed}
                              >
                                <option value="">Choose Caste</option>
                                {casteList.map((caste) => (
                                  <option
                                    key={caste.castE_ID}
                                    value={caste.castE_ID}
                                  >
                                    {caste.castE_NAME}
                                  </option>
                                ))}
                              </select>
                              {errors.caste_val && (
                                <div className="text-danger mt-1 small">
                                  {errors.caste_val}
                                </div>
                              )}
                            </div>

                            <div class="form-group mb-3">
                              <label>APAAR ID</label>
                              <input
                                maxlength="12"
                                type="text"
                                id="apaar_id"
                                name="apaar_id"
                                className={`form-control form-control-sm ${
                                  errors.apaar_id ? "is-invalid" : ""
                                }`}
                                placeholder="Enter APAAR ID"
                                value={formData.apaar_id}
                                onChange={handleChange}
                                // onBlur={handleApaarBlur}
                                disabled={isPreviewed}
                              />
                              {errors.apaar_id && (
                                <div className="text-danger mt-1 small">
                                  {errors.apaar_id}
                                </div>
                              )}
                            </div>

                            {/* <div class="form-group mb-4">
                              <label>
                                Academic Session{" "}
                                <span class="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                disabled={isPreviewed}
                                className={`form-control form-control-sm disable ${errors.academiC_SESSION ? "is-invalid" : ""
                                  }`}
                                maxlength="20"
                                id="academiC_SESSION"
                                name="academiC_SESSION"
                                value={formData.academiC_SESSION}
                                onChange={handleChange}
                                placeholder="Enter Academic Session"
                              />

                              {errors.academiC_SESSION && (
                                <div className="text-danger mt-1 small">
                                  {errors.academiC_SESSION}
                                </div>
                              )}
                            </div> */}

                            <div className="form-group mb-3">
                              <label>
                                Academic Session{" "}
                                <span className="text-danger">*</span>
                              </label>

                              <div className="row align-items-center">
                                {/* 20 */}
                                <div className="col-md-2 text-end pe-0">
                                  <span>20</span>
                                </div>

                                {/* input */}
                                <div
                                  className="col-md-3"
                                  style={{ padding: "7px" }}
                                >
                                  <input
                                    type="text"
                                    className={`form-control form-control-sm ${
                                      errors.academiC_SESSION1
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    maxLength="2"
                                    name="academiC_SESSION1"
                                    id="academiC_SESSION1"
                                    ref={session1Ref}
                                    value={formData.academiC_SESSION1}
                                    onChange={handleChange}
                                    disabled={isPreviewed}
                                  />
                                </div>

                                {/* dash */}
                                <div className="col-md-1 text-center">
                                  <span
                                    style={{
                                      fontSize: "28px",
                                      lineHeight: "20px",
                                    }}
                                  >
                                    -
                                  </span>
                                </div>

                                {/* 20 */}
                                <div className="col-md-2 text-end pe-0">
                                  <span>20</span>
                                </div>

                                {/* input */}
                                <div
                                  className="col-md-3"
                                  style={{ padding: "7px" }}
                                >
                                  <input
                                    type="text"
                                    className={`form-control form-control-sm ${
                                      errors.academiC_SESSION2
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    maxLength="2"
                                    name="academiC_SESSION2"
                                    id="academiC_SESSION2"
                                    ref={session2Ref}
                                    value={formData.academiC_SESSION2}
                                    onChange={handleChange}
                                    onKeyDown={handleKeyDown}
                                    disabled={isPreviewed}
                                  />
                                </div>
                              </div>
                              {(errors.academiC_SESSION1 ||
                                errors.academiC_SESSION2) && (
                                <div className="text-danger mt-1 small">
                                  {errors.academiC_SESSION1 ||
                                    errors.academiC_SESSION2}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12 mb-4 stretch-card">
                  <div class="card permanent-address">
                    <div class="card-header card-green">
                      <h4 class="mb-2 p-2">Permanent Address</h4>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div
                          class="col-lg-9 col-m-12"
                          style={{ borderRight: "1px solid #CED4DA" }}
                        >
                          <div class="row">
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group mb-3">
                                <label>
                                  Area <span class="text-danger">*</span>
                                </label>
                                <select
                                  className={`form-select form-control-sm  ${
                                    errors.area ? "is-invalid" : ""
                                  }`}
                                  name="area"
                                  id="area"
                                  value={formData.area}
                                  onChange={handleChange}
                                  disabled={isPreviewed}
                                >
                                  <option value="">Choose Area</option>
                                  <option value="RURAL">RURAL </option>
                                  <option value="URBAN">URBAN</option>
                                </select>
                                {errors.area && (
                                  <div className="text-danger mt-1 small">
                                    {errors.area}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group mb-3">
                                <label>
                                  State <span class="text-danger">*</span>
                                </label>
                                <Select
                                  name="state_val"
                                  id="state_val"
                                  options={stateList.map((state) => ({
                                    value: state.statE_CODE,
                                    label: state.statE_NAME,
                                  }))}
                                  isDisabled={isPreviewed}
                                  value={
                                    formData.state_val && stateList.length > 0
                                      ? {
                                          value: formData.state_val,
                                          label:
                                            stateList.find(
                                              (s) =>
                                                s.statE_CODE ===
                                                formData.state_val
                                            )?.statE_NAME || formData.state_val,
                                        }
                                      : null
                                  }
                                  onChange={(selectedOption) =>
                                    handleChange({
                                      target: {
                                        name: "state_val",
                                        value: selectedOption?.value || "",
                                      },
                                    })
                                  }
                                  className={
                                    errors.state_val
                                      ? "react-select is-invalid"
                                      : "react-select"
                                  }
                                />

                                {errors.state_val && (
                                  <div className="text-danger mt-1 small">
                                    {errors.state_val}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group mb-3">
                                <label>
                                  District <span class="text-danger">*</span>
                                </label>
                                <Select
                                  name="district_val"
                                  id="district_val"
                                  options={districtList
                                    .filter(
                                      (d) => d.statE_CODE === formData.state_val
                                    )
                                    .map((district) => ({
                                      value: district.districT_CODE,
                                      label: district.district,
                                    }))}
                                  value={
                                    formData.district_val
                                      ? {
                                          value: formData.district_val,
                                          label:
                                            districtList.find(
                                              (d) =>
                                                d.districT_CODE ===
                                                formData.district_val
                                            )?.district || "",
                                        }
                                      : null
                                  }
                                  onChange={(selectedOption) =>
                                    handleChange({
                                      target: {
                                        name: "district_val",
                                        value: selectedOption?.value || "",
                                      },
                                    })
                                  }
                                  isDisabled={
                                    !formData.state_val || isPreviewed
                                  }
                                  classNamePrefix={
                                    errors.district_val
                                      ? "react-select is-invalid"
                                      : "react-select"
                                  }
                                />
                                {errors.district_val && (
                                  <div className="text-danger mt-1 small">
                                    {errors.district_val}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group mb-3">
                                <label>
                                  Block <span class="text-danger">*</span>
                                </label>
                                <Select
                                  name="block_val"
                                  id="block_val"
                                  options={blockList
                                    .filter(
                                      (b) =>
                                        b.disT_CODE === formData.district_val
                                    )
                                    .map((block) => ({
                                      value: block.blocK_ID,
                                      label: block.blocK_NAME,
                                    }))}
                                  value={
                                    formData.block_val
                                      ? {
                                          value: formData.block_val,
                                          label:
                                            blockList.find(
                                              (b) =>
                                                b.blocK_ID ===
                                                formData.block_val
                                            )?.blocK_NAME || "",
                                        }
                                      : null
                                  }
                                  onChange={(selectedOption) =>
                                    handleChange({
                                      target: {
                                        name: "block_val",
                                        value: selectedOption?.value || "",
                                      },
                                    })
                                  }
                                  isDisabled={
                                    !formData.district_val || isPreviewed
                                  }
                                  classNamePrefix={
                                    errors.block_val
                                      ? "react-select is-invalid"
                                      : "react-select"
                                  }
                                />
                                {errors.block_val && (
                                  <div className="text-danger mt-1 small">
                                    {errors.block_val}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div class="col-lg-9 col-m-6">
                              <div class="form-group mb-3">
                                <label>
                                  Address <span class="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  name="address_val"
                                  className={`form-control form-control-sm  ${
                                    errors.address_val ? "is-invalid" : ""
                                  }`}
                                  maxlength="200"
                                  placeholder="Enter Your Address"
                                  value={formData.address_val.toUpperCase()}
                                  onChange={handleChange}
                                  disabled={isPreviewed}
                                />
                                {errors.address_val && (
                                  <div className="text-danger mt-1 small">
                                    {errors.address_val}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group mb-3">
                                <label>
                                  Pin Code <span class="text-danger">*</span>
                                </label>
                                <input
                                  autoComplete="off"
                                  type="text"
                                  className={`form-control form-control-sm ${
                                    errors.pin_no ? "is-invalid" : ""
                                  }`}
                                  name="pin_no"
                                  maxLength="6"
                                  placeholder="Enter Your Pincode"
                                  value={formData.pin_no}
                                  onChange={handleChange}
                                  disabled={isPreviewed}
                                />
                                {errors.pin_no && (
                                  <div className="text-danger mt-1 small">
                                    {errors.pin_no}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-3 col-m-12">
                          <div class="row">
                            <div class="form-group mb-3 col-m-6">
                              <label>
                                Contact Number{" "}
                                <span class="text-danger">*</span>
                              </label>
                              <input
                                autoComplete="off"
                                type="text"
                                id="contact_no"
                                name="contact_no"
                                className={`form-control form-control-sm ${
                                  errors.contact_no ? "is-invalid" : ""
                                }`}
                                maxlength="10"
                                placeholder="Student Contact Number"
                                value={formData.contact_no}
                                onChange={handleChange}
                                disabled={isPreviewed}
                              />
                              {errors.contact_no && (
                                <div className="text-danger mt-1 small">
                                  {errors.contact_no}
                                </div>
                              )}
                            </div>
                            <div class="form-group mb-3 col-m-6">
                              <label>Email ID</label>
                              <input
                                type="email"
                                name="email_id"
                                className={`form-control form-control-sm  ${
                                  errors.email_id ? "is-invalid" : ""
                                }`}
                                maxlength="100"
                                placeholder="Email ID"
                                value={formData.email_id}
                                onChange={handleChange}
                                disabled={isPreviewed}
                              />
                              {errors.email_id && (
                                <div className="text-danger mt-1 small">
                                  {errors.email_id}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {formData.stream && (
                  <div class="col-lg-12 col-m-12 mb-4 stretch-card">
                    <div class="card educational-details">
                      <div class="card-header card-green">
                        <h4 class="mb-0 p-2">Educational Details</h4>
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-12 mb-3">
                            <h4>Paper - 1</h4>
                            <hr />
                            <div class="row">
                              <div class="col-md-4">
                                <div class="form-group mb-3">
                                  <label>
                                    Core Language{" "}
                                    <span class="text-danger">*</span>
                                  </label>
                                  <select
                                    id="coresubject"
                                    className={`form-select  ${
                                      errors.coresubject ? "is-invalid" : ""
                                    }`}
                                    disabled={isPreviewed}
                                    name="coresubject"
                                    value={formData.coresubject || ""}
                                    onChange={(e) => {
                                      handleChange(e);
                                      const selectedText =
                                        e.target.options[e.target.selectedIndex]
                                          .text;
                                      setSelectedSubjectNames((prev) => ({
                                        ...prev,
                                        coresubject: selectedText,
                                      }));
                                      const selectedValue = e.target.value;
                                      if (
                                        selectedValue === "ENA" ||
                                        selectedValue === "HNA"
                                      ) {
                                        setFormData((prev) => ({
                                          ...prev,
                                          matribhasa: "",
                                        }));
                                        setSelectedSubjectNames((prev) => ({
                                          ...prev,
                                          matribhasa: "",
                                        }));
                                      }
                                    }}
                                  >
                                    <option value="">Choose Subject</option>
                                    {coresubject
                                      .filter((subject) => {
                                        const selectedIds = [
                                          formData.matribhasa,
                                          formData.compulsory_one,
                                          formData.compulsory_two,
                                          formData.additionalsubject,
                                          selectedArtsSubjects.arts_optional_one,
                                          selectedArtsSubjects.arts_optional_two,
                                          selectedArtsSubjects.arts_optional_three,
                                          optional1,
                                          optional2,
                                          artselective,
                                        ];
                                        const selectedNames =
                                          Object.values(selectedSubjectNames);
                                        return (
                                          subject.subjecT_ID ===
                                            formData.coresubject || // ✅ Keep current selection
                                          (!selectedIds.includes(
                                            subject.subjecT_ID
                                          ) &&
                                            !selectedNames.includes(
                                              subject.subjecT_NAME
                                            ))
                                        );
                                      })
                                      .map((subject) => (
                                        <option
                                          key={subject.subjecT_ID}
                                          value={subject.subjecT_ID}
                                        >
                                          {subject.subjecT_NAME}
                                        </option>
                                      ))}
                                  </select>
                                  {errors.coresubject && (
                                    <div className="text-danger mt-1 small">
                                      {errors.coresubject}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group mb-3">
                                  <label>
                                    Matri Bhasa{" "}
                                    <span class="text-danger">*</span>
                                  </label>
                                  <select
                                    id="matribhasa"
                                    className={`form-select  ${
                                      errors.matribhasa ? "is-invalid" : ""
                                    }`}
                                    name="matribhasa"
                                    value={formData.matribhasa || ""}
                                    onChange={(e) => {
                                      handleChange(e);
                                      const selectedText =
                                        e.target.options[e.target.selectedIndex]
                                          .text;
                                      setSelectedSubjectNames((prev) => ({
                                        ...prev,
                                        matribhasa: selectedText,
                                      }));
                                    }}
                                    disabled={
                                      formData.coresubject === "ENA" ||
                                      formData.coresubject === "HNA" ||
                                      isPreviewed ||
                                      !formData.coresubject
                                    }
                                  >
                                    <option value="">Choose Subject</option>
                                    {matribhasa
                                      .filter((subject) => {
                                        const selectedIds = [
                                          formData.coresubject,
                                          formData.compulsory_one,
                                          formData.compulsory_two,
                                          formData.additionalsubject,
                                          selectedArtsSubjects.arts_optional_one,
                                          selectedArtsSubjects.arts_optional_two,
                                          selectedArtsSubjects.arts_optional_three,
                                          optional1,
                                          optional2,
                                          artselective,
                                        ];
                                        const selectedNames =
                                          Object.values(selectedSubjectNames);
                                        return (
                                          subject.subjecT_ID ===
                                            formData.matribhasa || // ✅ Keep current selection
                                          (!selectedIds.includes(
                                            subject.subjecT_ID
                                          ) &&
                                            !selectedNames.includes(
                                              subject.subjecT_NAME
                                            ))
                                        );
                                      })
                                      .map((subject) => (
                                        <option
                                          key={subject.subjecT_ID}
                                          value={subject.subjecT_ID}
                                        >
                                          {subject.subjecT_NAME}
                                        </option>
                                      ))}
                                  </select>
                                  {errors.matribhasa && (
                                    <div className="text-danger mt-1 small">
                                      {errors.matribhasa}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="col-md-12 mb-3">
                            <h4>Paper - 2</h4>
                            <hr />
                            <div class="row">
                              {(formData.stream === "SCIENCE" ||
                                formData.stream === "COMMERCE") && (
                                <>
                                  <div className="col-md-4">
                                    <div className="form-group mb-3">
                                      <label>
                                        Compulsory 1{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        value={compulsoryonename}
                                        disabled
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-4">
                                    <div className="form-group mb-3">
                                      <label>
                                        Compulsory 2{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        value={compulsorytwoname}
                                        disabled
                                      />
                                    </div>
                                  </div>
                                </>
                              )}

                              {formData.stream === "ARTS" && (
                                <>
                                  <div className="col-md-4">
                                    <div className="form-group mb-3">
                                      <label>
                                        Optional 1{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className={`form-select ${
                                          errors.arts_optional_one
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        disabled={isPreviewed}
                                        id="arts_optional_one"
                                        name="arts_optional_one"
                                        value={
                                          selectedArtsSubjects.arts_optional_one
                                        }
                                        onChange={(e) => {
                                          handleArtsOptionalChange(e);
                                          const selectedText =
                                            e.target.options[
                                              e.target.selectedIndex
                                            ].text;
                                          setSelectedSubjectNames((prev) => ({
                                            ...prev,
                                            arts_optional_one: selectedText,
                                          }));
                                        }}
                                      >
                                        <option value="">Choose Subject</option>
                                        {optionalfiltersubj
                                          .filter((subject) => {
                                            const selectedIds = [
                                              formData.coresubject,
                                              formData.matribhasa,
                                              formData.compulsory_one,
                                              formData.compulsory_two,
                                              formData.additionalsubject,
                                              selectedArtsSubjects.arts_optional_two,
                                              selectedArtsSubjects.arts_optional_three,
                                              optional1,
                                              optional2,
                                              artselective,
                                            ];

                                            const selectedNames =
                                              Object.values(
                                                selectedSubjectNames
                                              );

                                            // ✅ Vocational restriction: only one vocational allowed
                                            const vocationalSelected = [
                                              selectedArtsSubjects.arts_optional_two,
                                              selectedArtsSubjects.arts_optional_three,
                                              artselective,
                                              formData.additionalsubject,
                                            ].some((id) => {
                                              if (!id) return false;
                                              return (
                                                artsSubjects.find(
                                                  (s) =>
                                                    s.subjecT_ID === id &&
                                                    s.vocational === "YES"
                                                ) ||
                                                optionalfiltersubj.find(
                                                  (s) =>
                                                    s.subjecT_ID === id &&
                                                    s.vocational === "YES"
                                                ) ||
                                                additionalfiltersubj.find(
                                                  (s) =>
                                                    s.subjecT_ID === id &&
                                                    s.vocational === "YES"
                                                )
                                              );
                                            });

                                            if (
                                              vocationalSelected &&
                                              subject.vocational === "YES" &&
                                              subject.subjecT_ID !==
                                                selectedArtsSubjects.arts_optional_one
                                            ) {
                                              return false;
                                            }

                                            // ✅ MAT/STA exclusion for Arts
                                            const artsOptionals = [
                                              selectedArtsSubjects.arts_optional_two,
                                              selectedArtsSubjects.arts_optional_three,
                                            ];
                                            if (
                                              artsOptionals.includes("MAT") &&
                                              subject.subjecT_ID === "STA"
                                            )
                                              return false;
                                            if (
                                              artsOptionals.includes("STA") &&
                                              subject.subjecT_ID === "MAT"
                                            )
                                              return false;

                                            // ✅ Keep current selection OR allow unselected subjects
                                            return (
                                              subject.subjecT_ID ===
                                                selectedArtsSubjects.arts_optional_one ||
                                              (!selectedIds.includes(
                                                subject.subjecT_ID
                                              ) &&
                                                !selectedNames.includes(
                                                  subject.subjecT_NAME
                                                ))
                                            );
                                          })
                                          .map((subject) => (
                                            <option
                                              key={subject.subjecT_ID}
                                              value={subject.subjecT_ID}
                                            >
                                              {subject.subjecT_NAME}
                                            </option>
                                          ))}
                                      </select>
                                      {errors.arts_optional_one && (
                                        <div className="text-danger mt-1 small">
                                          {errors.arts_optional_one}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-md-4">
                                    <div className="form-group mb-3">
                                      <label>
                                        Optional 2{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        disabled={isPreviewed}
                                        className={`form-select ${
                                          errors.arts_optional_two
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        id="arts_optional_two"
                                        name="arts_optional_two"
                                        value={
                                          selectedArtsSubjects.arts_optional_two
                                        }
                                        onChange={(e) => {
                                          handleArtsOptionalChange(e);
                                          const selectedText =
                                            e.target.options[
                                              e.target.selectedIndex
                                            ].text;
                                          setSelectedSubjectNames((prev) => ({
                                            ...prev,
                                            arts_optional_two: selectedText,
                                          }));
                                        }}
                                      >
                                        <option value="">Choose Subject</option>
                                        {optionalfiltersubj
                                          .filter((subject) => {
                                            const selectedIds = [
                                              formData.coresubject,
                                              formData.matribhasa,
                                              formData.compulsory_one,
                                              formData.compulsory_two,
                                              formData.additionalsubject,
                                              selectedArtsSubjects.arts_optional_one,
                                              selectedArtsSubjects.arts_optional_three,
                                              optional1,
                                              optional2,
                                              artselective,
                                            ];
                                            const selectedNames =
                                              Object.values(
                                                selectedSubjectNames
                                              );

                                            // ✅ Vocational restriction
                                            const vocationalSelected = [
                                              selectedArtsSubjects.arts_optional_one,
                                              selectedArtsSubjects.arts_optional_three,
                                              artselective,
                                              formData.additionalsubject,
                                            ].some(
                                              (id) =>
                                                id &&
                                                (artsSubjects.find(
                                                  (s) =>
                                                    s.subjecT_ID === id &&
                                                    s.vocational === "YES"
                                                ) ||
                                                  optionalfiltersubj.find(
                                                    (s) =>
                                                      s.subjecT_ID === id &&
                                                      s.vocational === "YES"
                                                  ) ||
                                                  additionalfiltersubj.find(
                                                    (s) =>
                                                      s.subjecT_ID === id &&
                                                      s.vocational === "YES"
                                                  ))
                                            );

                                            if (
                                              vocationalSelected &&
                                              subject.vocational === "YES" &&
                                              subject.subjecT_ID !==
                                                selectedArtsSubjects.arts_optional_two
                                            ) {
                                              return false;
                                            }

                                            // ✅ MAT/STA exclusion
                                            const artsOptionals = [
                                              selectedArtsSubjects.arts_optional_one,
                                              selectedArtsSubjects.arts_optional_three,
                                            ].filter(Boolean);

                                            if (
                                              artsOptionals.includes("MAT") &&
                                              subject.subjecT_ID === "STA"
                                            )
                                              return false;
                                            if (
                                              artsOptionals.includes("STA") &&
                                              subject.subjecT_ID === "MAT"
                                            )
                                              return false;

                                            return (
                                              subject.subjecT_ID ===
                                                selectedArtsSubjects.arts_optional_two ||
                                              (!selectedIds.includes(
                                                subject.subjecT_ID
                                              ) &&
                                                !selectedNames.includes(
                                                  subject.subjecT_NAME
                                                ))
                                            );
                                          })
                                          .map((subject) => (
                                            <option
                                              key={subject.subjecT_ID}
                                              value={subject.subjecT_ID}
                                            >
                                              {subject.subjecT_NAME}
                                            </option>
                                          ))}
                                      </select>

                                      {errors.arts_optional_two && (
                                        <div className="text-danger mt-1 small">
                                          {errors.arts_optional_two}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-md-4">
                                    <div className="form-group mb-3">
                                      <label>
                                        Optional 3{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        disabled={isPreviewed}
                                        className={`form-select ${
                                          errors.arts_optional_three
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        id="arts_optional_three"
                                        name="arts_optional_three"
                                        value={
                                          selectedArtsSubjects.arts_optional_three
                                        }
                                        onChange={(e) => {
                                          handleArtsOptionalChange(e);
                                          const selectedText =
                                            e.target.options[
                                              e.target.selectedIndex
                                            ].text;
                                          setSelectedSubjectNames((prev) => ({
                                            ...prev,
                                            arts_optional_three: selectedText,
                                          }));
                                        }}
                                      >
                                        <option value="">Choose Subject</option>
                                        {optionalfiltersubj
                                          .filter((subject) => {
                                            const selectedIds = [
                                              formData.coresubject,
                                              formData.matribhasa,
                                              formData.compulsory_one,
                                              formData.compulsory_two,
                                              formData.additionalsubject,
                                              selectedArtsSubjects.arts_optional_one,
                                              selectedArtsSubjects.arts_optional_two,
                                              optional1,
                                              optional2,
                                              artselective,
                                            ];
                                            const selectedNames =
                                              Object.values(
                                                selectedSubjectNames
                                              );

                                            // ✅ Vocational restriction
                                            const vocationalSelected = [
                                              selectedArtsSubjects.arts_optional_one,
                                              selectedArtsSubjects.arts_optional_two,
                                              artselective,
                                              formData.additionalsubject,
                                            ].some(
                                              (id) =>
                                                id &&
                                                (artsSubjects.find(
                                                  (s) =>
                                                    s.subjecT_ID === id &&
                                                    s.vocational === "YES"
                                                ) ||
                                                  optionalfiltersubj.find(
                                                    (s) =>
                                                      s.subjecT_ID === id &&
                                                      s.vocational === "YES"
                                                  ) ||
                                                  additionalfiltersubj.find(
                                                    (s) =>
                                                      s.subjecT_ID === id &&
                                                      s.vocational === "YES"
                                                  ))
                                            );

                                            if (
                                              vocationalSelected &&
                                              subject.vocational === "YES" &&
                                              subject.subjecT_ID !==
                                                selectedArtsSubjects.arts_optional_three
                                            ) {
                                              return false;
                                            }

                                            // ✅ MAT/STA exclusion
                                            const artsOptionals = [
                                              selectedArtsSubjects.arts_optional_one,
                                              selectedArtsSubjects.arts_optional_two,
                                            ].filter(Boolean);

                                            if (
                                              artsOptionals.includes("MAT") &&
                                              subject.subjecT_ID === "STA"
                                            )
                                              return false;
                                            if (
                                              artsOptionals.includes("STA") &&
                                              subject.subjecT_ID === "MAT"
                                            )
                                              return false;

                                            return (
                                              subject.subjecT_ID ===
                                                selectedArtsSubjects.arts_optional_three ||
                                              (!selectedIds.includes(
                                                subject.subjecT_ID
                                              ) &&
                                                !selectedNames.includes(
                                                  subject.subjecT_NAME
                                                ))
                                            );
                                          })
                                          .map((subject) => (
                                            <option
                                              key={subject.subjecT_ID}
                                              value={subject.subjecT_ID}
                                            >
                                              {subject.subjecT_NAME}
                                            </option>
                                          ))}
                                      </select>

                                      {errors.arts_optional_three && (
                                        <div className="text-danger mt-1 small">
                                          {errors.arts_optional_three}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>

                          <div class="col-md-12 mb-3">
                            <h4>Paper - 3</h4>
                            <hr />
                            <div class="row">
                              {(formData.stream === "SCIENCE" ||
                                formData.stream === "COMMERCE") && (
                                <>
                                  <div class="col-md-4">
                                    <div class="form-group mb-3">
                                      <label>
                                        Optional 1{" "}
                                        <span class="text-danger">*</span>
                                      </label>
                                      <select
                                        className={`form-select ${
                                          errors.sc_optional_one
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        disabled={isPreviewed}
                                        id="sc_optional_one"
                                        name="sc_optional_one"
                                        value={optional1}
                                        onChange={(e) => {
                                          setOptional1(e.target.value);
                                          const selectedText =
                                            e.target.options[
                                              e.target.selectedIndex
                                            ].text;

                                          // Update name state
                                          setSelectedSubjectNames((prev) => ({
                                            ...prev,
                                            optional1: selectedText,
                                          }));
                                        }}
                                      >
                                        <option value="">Choose Subject</option>
                                        {optionalfiltersubj
                                          .filter((subject) => {
                                            const selectedIds = [
                                              formData.coresubject,
                                              formData.matribhasa,
                                              formData.compulsory_one,
                                              formData.compulsory_two,
                                              formData.additionalsubject,
                                              selectedArtsSubjects.arts_optional_one,
                                              selectedArtsSubjects.arts_optional_two,
                                              selectedArtsSubjects.arts_optional_three,
                                              optional2,
                                              artselective,
                                            ];

                                            const selectedNames =
                                              Object.values(
                                                selectedSubjectNames
                                              );

                                            const vocationalSelected =
                                              (optional2 &&
                                                optionalfiltersubj.find(
                                                  (s) =>
                                                    s.subjecT_ID ===
                                                      optional2 &&
                                                    s.vocational === "YES"
                                                )) ||
                                              (formData.additionalsubject &&
                                                optionalfiltersubj.find(
                                                  (s) =>
                                                    s.subjecT_ID ===
                                                      formData.additionalsubject &&
                                                    s.vocational === "YES"
                                                ));

                                            if (
                                              vocationalSelected &&
                                              subject.vocational === "YES" &&
                                              subject.subjecT_ID !== optional1
                                            ) {
                                              return false; // hide all vocational except the one already chosen
                                            }

                                            // ✅ Science stream condition
                                            if (formData.stream === "SCIENCE") {
                                              // If Optional 2 or Additional subject is MAT, remove STA here
                                              if (
                                                (optional2 === "MAT" ||
                                                  formData.additionalsubject ===
                                                    "MAT") &&
                                                subject.subjecT_ID === "STA"
                                              ) {
                                                return false;
                                              }
                                              // If Optional 2 or Additional subject is STA, remove MAT here
                                              if (
                                                (optional2 === "STA" ||
                                                  formData.additionalsubject ===
                                                    "STA") &&
                                                subject.subjecT_ID === "MAT"
                                              ) {
                                                return false;
                                              }
                                            }

                                            // ✅ Commerce stream condition
                                            if (
                                              formData.stream === "COMMERCE"
                                            ) {
                                              // If Optional 2 or Additional subject is MAT, remove CAE
                                              if (
                                                (optional2 === "MAT" ||
                                                  formData.additionalsubject ===
                                                    "MAT") &&
                                                subject.subjecT_ID === "CAE"
                                              ) {
                                                return false;
                                              }
                                              // If Optional 2 or Additional subject is CAE, remove MAT
                                              if (
                                                (optional2 === "CAE" ||
                                                  formData.additionalsubject ===
                                                    "CAE") &&
                                                subject.subjecT_ID === "MAT"
                                              ) {
                                                return false;
                                              }
                                            }

                                            // ✅ Keep current selection OR allow only unselected subjects
                                            return (
                                              subject.subjecT_ID ===
                                                optional1 ||
                                              (!selectedIds.includes(
                                                subject.subjecT_ID
                                              ) &&
                                                !selectedNames.includes(
                                                  subject.subjecT_NAME
                                                ))
                                            );
                                          })
                                          .map((subject) => (
                                            <option
                                              key={subject.subjecT_ID}
                                              value={subject.subjecT_ID}
                                            >
                                              {subject.subjecT_NAME}
                                            </option>
                                          ))}
                                      </select>

                                      {errors.sc_optional_one && (
                                        <div className="text-danger mt-1 small">
                                          {errors.sc_optional_one}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <div class="form-group mb-3">
                                      <label>
                                        Optional 2{" "}
                                        <span class="text-danger">*</span>
                                      </label>
                                      <select
                                        disabled={isPreviewed}
                                        className={`form-select ${
                                          errors.sc_optional_two
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        id="sc_optional_two"
                                        name="sc_optional_two"
                                        value={optional2}
                                        onChange={(e) => {
                                          setOptional2(e.target.value);
                                          const selectedText =
                                            e.target.options[
                                              e.target.selectedIndex
                                            ].text;

                                          // Update name state
                                          setSelectedSubjectNames((prev) => ({
                                            ...prev,
                                            optional2: selectedText,
                                          }));
                                        }}
                                      >
                                        <option value="">Choose Subject</option>
                                        {optionalfiltersubj
                                          .filter((subject) => {
                                            const selectedIds = [
                                              formData.coresubject,
                                              formData.matribhasa,
                                              formData.compulsory_one,
                                              formData.compulsory_two,
                                              formData.additionalsubject,
                                              selectedArtsSubjects.arts_optional_one,
                                              selectedArtsSubjects.arts_optional_two,
                                              selectedArtsSubjects.arts_optional_three,
                                              optional1,
                                              artselective,
                                            ];

                                            const selectedNames =
                                              Object.values(
                                                selectedSubjectNames
                                              );

                                            const vocationalSelected =
                                              (optional1 &&
                                                optionalfiltersubj.find(
                                                  (s) =>
                                                    s.subjecT_ID ===
                                                      optional1 &&
                                                    s.vocational === "YES"
                                                )) ||
                                              (formData.additionalsubject &&
                                                optionalfiltersubj.find(
                                                  (s) =>
                                                    s.subjecT_ID ===
                                                      formData.additionalsubject &&
                                                    s.vocational === "YES"
                                                ));

                                            if (
                                              vocationalSelected &&
                                              subject.vocational === "YES" &&
                                              subject.subjecT_ID !== optional2
                                            ) {
                                              return false; // hide all vocational except the one already chosen
                                            }

                                            // ✅ Science stream condition
                                            if (formData.stream === "SCIENCE") {
                                              if (
                                                (optional1 === "MAT" ||
                                                  formData.additionalsubject ===
                                                    "MAT") &&
                                                subject.subjecT_ID === "STA"
                                              ) {
                                                return false;
                                              }
                                              if (
                                                (optional1 === "STA" ||
                                                  formData.additionalsubject ===
                                                    "STA") &&
                                                subject.subjecT_ID === "MAT"
                                              ) {
                                                return false;
                                              }
                                            }

                                            // ✅ Commerce stream condition
                                            if (
                                              formData.stream === "COMMERCE"
                                            ) {
                                              if (
                                                (optional1 === "MAT" ||
                                                  formData.additionalsubject ===
                                                    "MAT") &&
                                                subject.subjecT_ID === "CAE"
                                              ) {
                                                return false;
                                              }
                                              if (
                                                (optional1 === "CAE" ||
                                                  formData.additionalsubject ===
                                                    "CAE") &&
                                                subject.subjecT_ID === "MAT"
                                              ) {
                                                return false;
                                              }
                                            }

                                            // ✅ Keep current selection OR allow only unselected subjects
                                            return (
                                              subject.subjecT_ID ===
                                                optional2 ||
                                              (!selectedIds.includes(
                                                subject.subjecT_ID
                                              ) &&
                                                !selectedNames.includes(
                                                  subject.subjecT_NAME
                                                ))
                                            );
                                          })
                                          .map((subject) => (
                                            <option
                                              key={subject.subjecT_ID}
                                              value={subject.subjecT_ID}
                                            >
                                              {subject.subjecT_NAME}
                                            </option>
                                          ))}
                                      </select>

                                      {errors.sc_optional_two && (
                                        <div className="text-danger mt-1 small">
                                          {errors.sc_optional_two}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </>
                              )}
                              {formData.stream === "ARTS" && (
                                <div className="col-md-4">
                                  <div className="form-group mb-3">
                                    <label>
                                      Elective Language{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <select
                                      className={`form-select ${
                                        errors.arts_elective_one
                                          ? "is-invalid"
                                          : ""
                                      }`}
                                      disabled={isPreviewed}
                                      id="arts_elective_one"
                                      name="arts_elective_one"
                                      value={artselective}
                                      onChange={(e) => {
                                        setArtselective(e.target.value);
                                        const selectedText =
                                          e.target.options[
                                            e.target.selectedIndex
                                          ].text;
                                        setSelectedSubjectNames((prev) => ({
                                          ...prev,
                                          artselective: selectedText,
                                        }));
                                      }}
                                    >
                                      <option value="">Choose Subject</option>
                                      {electivefiltersubj
                                        .filter((subject) => {
                                          const selectedIds = [
                                            formData.coresubject,
                                            formData.matribhasa,
                                            formData.compulsory_one,
                                            formData.compulsory_two,
                                            formData.additionalsubject,
                                            selectedArtsSubjects.arts_optional_one,
                                            selectedArtsSubjects.arts_optional_two,
                                            selectedArtsSubjects.arts_optional_three,
                                            optional1,
                                            optional2,
                                          ];
                                          const selectedNames =
                                            Object.values(selectedSubjectNames);

                                          // ✅ Vocational restriction
                                          const vocationalSelected =
                                            (selectedArtsSubjects.arts_optional_one &&
                                              artsSubjects.find(
                                                (s) =>
                                                  s.subjecT_ID ===
                                                    selectedArtsSubjects.arts_optional_one &&
                                                  s.vocational === "YES"
                                              )) ||
                                            (selectedArtsSubjects.arts_optional_two &&
                                              artsSubjects.find(
                                                (s) =>
                                                  s.subjecT_ID ===
                                                    selectedArtsSubjects.arts_optional_two &&
                                                  s.vocational === "YES"
                                              )) ||
                                            (selectedArtsSubjects.arts_optional_three &&
                                              artsSubjects.find(
                                                (s) =>
                                                  s.subjecT_ID ===
                                                    selectedArtsSubjects.arts_optional_three &&
                                                  s.vocational === "YES"
                                              )) ||
                                            (formData.additionalsubject &&
                                              additionalfiltersubj.find(
                                                (s) =>
                                                  s.subjecT_ID ===
                                                    formData.additionalsubject &&
                                                  s.vocational === "YES"
                                              ));

                                          if (
                                            vocationalSelected &&
                                            subject.vocational === "YES" &&
                                            subject.subjecT_ID !== artselective
                                          ) {
                                            return false;
                                          }
                                          if (
                                            formData.coresubject === "HNA" &&
                                            subject.subjecT_ID === "HIN"
                                          ) {
                                            return false;
                                          }
                                          if (
                                            formData.coresubject === "ENA" &&
                                            (subject.subjecT_ID === "ENG" ||
                                              subject.subjecT_ID === "FEN")
                                          ) {
                                            return false;
                                          }
                                          return (
                                            subject.subjecT_ID ===
                                              artselective ||
                                            (!selectedIds.includes(
                                              subject.subjecT_ID
                                            ) &&
                                              !selectedNames.includes(
                                                subject.subjecT_NAME
                                              ))
                                          );
                                        })
                                        .map((subject) => (
                                          <option
                                            key={subject.subjecT_ID}
                                            value={subject.subjecT_ID}
                                          >
                                            {subject.subjecT_NAME}
                                          </option>
                                        ))}
                                    </select>
                                    {errors.arts_elective_one && (
                                      <div className="text-danger mt-1 small">
                                        {errors.arts_elective_one}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>

                          <div class="col-md-12">
                            <h4>Additional Subject </h4>
                            <hr />
                            <div class="row">
                              <div className="col-md-4 mb-2">
                                <div className="form-group mb-3">
                                  <select
                                    disabled={isPreviewed}
                                    className="form-select"
                                    id="additionalsubject"
                                    name="additionalsubject"
                                    value={formData.additionalsubject || ""}
                                    onChange={(e) => {
                                      handleChange(e);
                                      const selectedText =
                                        e.target.options[e.target.selectedIndex]
                                          .text;

                                      setSelectedSubjectNames((prev) => ({
                                        ...prev,
                                        additionalsubject: selectedText,
                                      }));
                                    }}
                                  >
                                    <option value="">Choose Subject</option>
                                    {additionalfiltersubj
                                      .filter((subject) => {
                                        const selectedIds = [
                                          formData.coresubject,
                                          formData.matribhasa,
                                          formData.compulsory_one,
                                          formData.compulsory_two,
                                          selectedArtsSubjects.arts_optional_one,
                                          selectedArtsSubjects.arts_optional_two,
                                          selectedArtsSubjects.arts_optional_three,
                                          optional1,
                                          optional2,
                                          artselective,
                                        ];

                                        const selectedNames =
                                          Object.values(selectedSubjectNames);

                                        const vocationalSelected =
                                          (optional1 &&
                                            additionalfiltersubj.find(
                                              (s) =>
                                                s.subjecT_ID === optional1 &&
                                                s.vocational === "YES"
                                            )) ||
                                          (optional2 &&
                                            additionalfiltersubj.find(
                                              (s) =>
                                                s.subjecT_ID === optional2 &&
                                                s.vocational === "YES"
                                            )) ||
                                          (selectedArtsSubjects.arts_optional_one &&
                                            additionalfiltersubj.find(
                                              (s) =>
                                                s.subjecT_ID ===
                                                  selectedArtsSubjects.arts_optional_one &&
                                                s.vocational === "YES"
                                            )) ||
                                          (selectedArtsSubjects.arts_optional_two &&
                                            additionalfiltersubj.find(
                                              (s) =>
                                                s.subjecT_ID ===
                                                  selectedArtsSubjects.arts_optional_two &&
                                                s.vocational === "YES"
                                            )) ||
                                          (selectedArtsSubjects.arts_optional_three &&
                                            additionalfiltersubj.find(
                                              (s) =>
                                                s.subjecT_ID ===
                                                  selectedArtsSubjects.arts_optional_three &&
                                                s.vocational === "YES"
                                            )) ||
                                          (artselective &&
                                            additionalfiltersubj.find(
                                              (s) =>
                                                s.subjecT_ID === artselective &&
                                                s.vocational === "YES"
                                            ));

                                        if (
                                          vocationalSelected &&
                                          subject.vocational === "YES" &&
                                          subject.subjecT_ID !==
                                            formData.additionalsubject
                                        ) {
                                          return false; // hide all vocational except the one already chosen
                                        }
                                        // ✅ Language-based restrictions
                                        if (
                                          formData.coresubject === "HNA" &&
                                          subject.subjecT_ID === "HIN"
                                        ) {
                                          return false;
                                        }
                                        if (
                                          formData.coresubject === "ENA" &&
                                          (subject.subjecT_ID === "ENG" ||
                                            subject.subjecT_ID === "FEN")
                                        ) {
                                          return false;
                                        }

                                        // ✅ Science stream restrictions
                                        if (formData.stream === "SCIENCE") {
                                          if (
                                            (optional1 === "MAT" ||
                                              optional2 === "MAT") &&
                                            subject.subjecT_ID === "STA"
                                          ) {
                                            return false;
                                          }
                                          if (
                                            (optional1 === "STA" ||
                                              optional2 === "STA") &&
                                            subject.subjecT_ID === "MAT"
                                          ) {
                                            return false;
                                          }
                                        }

                                        // ✅ Commerce stream restrictions
                                        if (formData.stream === "COMMERCE") {
                                          if (
                                            (optional1 === "MAT" ||
                                              optional2 === "MAT") &&
                                            subject.subjecT_ID === "CAE"
                                          ) {
                                            return false;
                                          }
                                          if (
                                            (optional1 === "CAE" ||
                                              optional2 === "CAE") &&
                                            subject.subjecT_ID === "MAT"
                                          ) {
                                            return false;
                                          }
                                        }

                                        // ✅ Arts stream MAT/STA restrictions
                                        if (formData.stream === "ARTS") {
                                          const {
                                            arts_optional_one,
                                            arts_optional_two,
                                            arts_optional_three,
                                          } = selectedArtsSubjects;

                                          // If MAT selected anywhere, remove both MAT & STA
                                          if (
                                            arts_optional_one === "MAT" ||
                                            arts_optional_two === "MAT" ||
                                            arts_optional_three === "MAT"
                                          ) {
                                            if (
                                              subject.subjecT_ID === "MAT" ||
                                              subject.subjecT_ID === "STA"
                                            ) {
                                              return false;
                                            }
                                          }

                                          // If STA selected anywhere, remove both STA & MAT
                                          if (
                                            arts_optional_one === "STA" ||
                                            arts_optional_two === "STA" ||
                                            arts_optional_three === "STA"
                                          ) {
                                            if (
                                              subject.subjecT_ID === "STA" ||
                                              subject.subjecT_ID === "MAT"
                                            ) {
                                              return false;
                                            }
                                          }
                                        }

                                        // ✅ Keep current selection OR allow unselected subjects
                                        return (
                                          subject.subjecT_ID ===
                                            formData.additionalsubject ||
                                          (!selectedIds.includes(
                                            subject.subjecT_ID
                                          ) &&
                                            !selectedNames.includes(
                                              subject.subjecT_NAME
                                            ))
                                        );
                                      })
                                      .map((subject) => (
                                        <option
                                          key={subject.subjecT_ID}
                                          value={subject.subjecT_ID}
                                        >
                                          {subject.subjecT_NAME}
                                        </option>
                                      ))}
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div class="col-md-12">
                  <div class="card">
                    <div class="card-body">
                      <div className="row">
                        <div className="col-md-8">
                          {isPreviewed && (
                            <h6 style={{ color: "red" }}>
                              <input
                                type="checkbox"
                                checked={isAgreed}
                                onChange={(e) => setIsAgreed(e.target.checked)}
                              />{" "}
                              I AGREE THAT ALL THE INFORMATION GIVEN ABOVE IS
                              CORRECT AS PER MY BEST KNOWLEDGE.
                            </h6>
                          )}
                        </div>
                        <div
                          style={{ textAlign: "right" }}
                          className="col-md-4"
                        >
                          {isPreviewed ? (
                            <>
                              <button
                                onClick={handleButtonClick}
                                type="button"
                                className="btn btn-primary pull-right"
                              >
                                <i className="fa fa-save me-1"></i>
                                Submit
                              </button>
                              <button
                                type="button"
                                onClick={() => setIsPreviewed(false)}
                                className="btn btn-secondary me-2"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </button>
                            </>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary me-2"
                              onClick={handlePreview}
                            >
                              <i className="fa fa-eye me-1"></i> Preview
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Footer11 />
          </div>
        </div>
      </div>
    </>
  );
}

export default DataNotFound11;
